<template>
  <div>
    <el-dialog title="修改密码" :visible.sync="isShow" @open="changePasswordDialogOpen" @close="changePasswordDialogClose" width="30%">
      <el-form :model="ruleForm2" label-width="auto" ref="ruleForm2">
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input type="text" v-model="ruleForm2.phoneNumber" @input="countSum('phoneNumber', ruleForm2.phoneNumber)" placeholder="请输入手机号" :disabled="true" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="VerificationCode">
          <div class="dis_line">
            <el-input type="text" v-model="ruleForm2.VerificationCode" placeholder="请输入验证码" size="mini"></el-input>
            <el-button type="primary" @click="resetForm" size="mini" style="margin-left: 10px;">发送验证码</el-button>
          </div>
        </el-form-item>
        <el-form-item label="输入新密码" prop="newPassword1">
          <el-input type="password" v-model="ruleForm2.newPassword1" placeholder="请输入新密码" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="newPassword">
          <el-input type="password" v-model="ruleForm2.newPassword" placeholder="请输入新密码" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordDialogClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm2')" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { cellphoneNumVerify } from "@/utils/validate";
import { update, sends } from "@/api/forgotpassword";
export default {
  props: {
    phoneNumber: {
      type: String,
      default: function() {
        return "";
      }
    },

    isShow: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  
  data() {
    return {
      ruleForm2: {
        phoneNumber: "",
        VerificationCode: "",
        newPassword1: "",
        newPassword: "",
      },
    };
  },
  methods: {
    changePasswordDialogClose() {
      this.$emit("changePasswordDialogClose");
    },

    changePasswordDialogOpen() {
      this.ruleForm2.phoneNumber = localStorage.getItem("phoneNumber");
    },
    
    submitForm(formName) {
      if(!cellphoneNumVerify(this.ruleForm2.phoneNumber)) {
        return this.$message.warning("输入的手机号格式错误");
      }
      if(!this.ruleForm2.VerificationCode) {
        return this.$message.warning("请输入验证码");
      }
      if(!this.ruleForm2.newPassword1) {
        return this.$message.warning("请输入新密码");
      }
      let rule = /((?=.*[0-9])(?=.*[a-z])|(?=.*[0-9])(?=.*[A-Z])).{8,17}$/;
      if(!rule.test(this.ruleForm2.newPassword1)) {
        this.$message.error("请输入正确的密码:至少8～16位，由数字字母符号（非纯数字、非纯字母）组成");
      }
      if(!this.ruleForm2.newPassword) {
        return this.$message.warning("请重复新密码");
      }
      if(JSON.stringify(this.ruleForm2.newPassword1) != JSON.stringify(this.ruleForm2.newPassword)) {
        return this.$message.warning("两次密码不一致");
      }
      this.$refs[formName].validate((valid) => {
        update(this.ruleForm2).then((response) => {
          if (200 == response.data.code) {
            this.$emit("changePasswordDialogClose");
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            if (response.data.code == 1018) {
              this.$message.error("请输入正确的密码:至少8～16位，由数字字母符号（非纯数字、非纯字母）组成");
              return
            }
            this.$message({
              type: "error",
              message: "修改失败",
            });
          }
        });
      });
    },

    resetForm() {
      if(!cellphoneNumVerify(this.ruleForm2.phoneNumber)) {
        return this.$message.warning("输入的手机号格式错误");
      }
      sends(this.ruleForm2.phoneNumber).then((response) => {
        if (200 == response.data.code) {
          this.$message({
            type: "success",
            message: "发送成功",
          });
        }
      });
    },

    countSum(str, num) {
			if(str == "phoneNumber") {
				this.ruleForm2.phoneNumber = num.replace(/[^\d]/g, "");
			}
		},
  }
};
</script>

<style scoped>
.dis_line {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/forgotpassword/forgotpasswords.vue